import React from 'react';
import { motion } from 'framer-motion';
import { HeartCrackIcon, UsersIcon, TrendingDownIcon, HelpCircleIcon, ClockIcon } from 'lucide-react';
const problems = [{
  icon: ClockIcon,
  text: 'Sentís que todo se volvió rutina y costumbre'
}, {
  icon: UsersIcon,
  text: 'Te comparás con otras mujeres y eso te genera inseguridad'
}, {
  icon: TrendingDownIcon,
  text: 'Sentís que estás más distante que conectada con tu pareja'
}, {
  icon: HeartCrackIcon,
  text: 'Querés volver a sentir esa energía del principio pero no sabés cómo lograrlo'
}, {
  icon: HelpCircleIcon,
  text: 'Te preguntás constantemente qué cambió en la relación'
}];
export function ProblemSection() {
  return <section className="pt-4 pb-10 md:pt-12 md:pb-16 px-6" data-id="element-169">
      <div className="max-w-2xl mx-auto" data-id="element-170">
        {/* Header — editorial */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-7 md:mb-12" data-id="element-171">
          <p className="text-[11px] md:text-xs tracking-[0.25em] uppercase text-burgundy/60 font-medium mb-4" data-id="element-172">
            Este programa es para vos
          </p>
          <h2 className="font-playfair text-[26px] md:text-4xl text-burgundy leading-tight font-light mb-5" data-id="element-173">
            Sentís que algo cambió
            <br data-id="element-174" />
            <span className="italic" data-id="element-175">… pero no sabés qué.</span>
          </h2>
          <div className="w-10 h-px bg-gold/60 mx-auto" data-id="element-176" />
        </motion.div>

        {/* Editorial list — no cards, just typography with hairline dividers */}
        <div className="mb-12 md:mb-16" data-id="element-177">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className={`flex items-start gap-4 py-4 md:py-5 ${index !== problems.length - 1 ? 'border-b border-burgundy/10' : ''}`} data-id="element-178">
              <problem.icon className="w-5 h-5 text-burgundy/70 flex-shrink-0 mt-1" strokeWidth={1.5} data-id="element-179" />
              <p className="text-charcoal/75 text-[15px] md:text-base leading-relaxed" data-id="element-180">
                {problem.text}
              </p>
            </motion.div>)}
        </div>

        {/* Editorial reveal — flowing prose, no card, no shadow */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-xl mx-auto" data-id="element-181">
          <p className="text-[14px] md:text-base text-charcoal/55 mb-3 italic font-light" data-id="element-182">
            "Es normal en relaciones largas." "Es la rutina." "Es el tiempo."
          </p>
          <p className="text-[13px] md:text-sm tracking-[0.18em] uppercase text-burgundy/60 font-medium mb-6" data-id="element-183">
            Pero la realidad es otra
          </p>

          <p className="font-playfair text-[20px] md:text-2xl text-charcoal/85 leading-snug mb-6 font-light" data-id="element-184">
            La atracción no desaparece.
            <br data-id="element-185" />
            <span className="italic" data-id="element-186">Se apaga cuando la dinámica cambia.</span>
          </p>

          <div className="w-10 h-px bg-gold/60 mx-auto mb-6" data-id="element-187" />

          <p className="font-playfair text-[20px] md:text-2xl text-burgundy leading-snug font-light" data-id="element-188">
            Y si se apagó…
            <br data-id="element-189" />
            <span className="italic" data-id="element-190">también se puede volver a encender.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}